import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("canvas", { id: "webgl" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { id: "scrollProgress" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("main", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "3Dスクロールアニメーション"),
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "スクロールを開始してください")
  ]),
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "オブジェクトの位置が変わります"),
    /*#__PURE__*/_createElementVNode("p", null, "ボックスの位置が変わっています")
  ]),
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "オブジェクトの位置が変わります"),
    /*#__PURE__*/_createElementVNode("p", null, "ボックスの位置が変わっています")
  ]),
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "オブジェクトの位置が変わります"),
    /*#__PURE__*/_createElementVNode("p", null, "カメラの位置が変わっています")
  ]),
  /*#__PURE__*/_createElementVNode("section", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "一番下にいます"),
    /*#__PURE__*/_createElementVNode("p", null, "立方体が自動回転しています"),
    /*#__PURE__*/_createElementVNode("p", null, "上にスクロールしてアニメーションを反転できます")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
}